import { jSith } from "../jquery-replacement";

export namespace S25Fetch {
    const ScriptPromises: Map<string, Promise<boolean>> = new Map<string, Promise<boolean>>();

    export function getBlobFromUrl(url: string) {
        const defer = jSith.defer();

        const xhr = new XMLHttpRequest();
        xhr.onload = function () {
            const reader = new FileReader();

            reader.onloadend = function () {
                defer.resolve(reader.result);
            };

            reader.onerror = function () {
                defer.resolve(null);
            };

            reader.onabort = function () {
                defer.resolve(null);
            };

            if (xhr.status >= 300) {
                defer.resolve(null);
            } else {
                reader.readAsDataURL(xhr.response);
            }
        };

        xhr.onerror = function () {
            defer.resolve(null);
        };

        xhr.onabort = function () {
            defer.resolve(null);
        };

        xhr.open("GET", url);
        xhr.responseType = "blob";
        xhr.send();

        return defer.promise;
    }

    export function toDataUri(url: string, replSource?: string, replTarget?: string): any {
        replSource = replSource || "https://";
        replTarget = replTarget || "http://";
        return getBlobFromUrl(url).then(function (resp) {
            //get blob from url
            if (resp) {
                //return blob
                return resp;
            } else {
                //no blob found
                if (url.indexOf(replSource) > -1) {
                    //try again, replacing source w/ target
                    url = url.replace(replSource, replTarget);
                    return toDataUri(url);
                }
                return null;
            }
        });
    }

    export function getPayload(
        rootName: string,
        itemNodeName: string,
        idNodeName: string,
        status: string,
        itemId: number | string,
        objExtend: any,
    ) {
        const payload: any = {};
        if (rootName) {
            let item: any = {};
            item[idNodeName] = itemId;
            item = Object.assign(item, objExtend || {});
            item.status = status;

            payload[rootName] = {};
            payload[rootName][itemNodeName] = item;
        }
        return payload;
    }

    export function loadScript(uniqueName: string, path: string): Promise<boolean> {
        const existingPromise = ScriptPromises.get(uniqueName);
        if (existingPromise) {
            return existingPromise;
        }

        const defer = jSith.defer();
        ScriptPromises.set(uniqueName, defer.promise);

        let tagName = "script";
        let pathProp = "src";
        let rel = "";
        if (path.endsWith("css")) {
            tagName = "link";
            pathProp = "href";
            rel = "stylesheet";
        }
        const script = document.createElement(tagName);
        if (rel) {
            script.rel = "stylesheet";
        }
        script.onload = () => {
            defer.resolve(true);
        };
        script.onerror = () => {
            ScriptPromises.delete(uniqueName);
            defer.reject(new Error(`Failed to load ${path}`));
        };
        script[pathProp] = path;

        document.head.appendChild(script);

        return defer.promise;
    }
}
